import * as React from 'react';
import { Button, ButtonProps, CircularProgress } from '@material-ui/core';

/**
 * Reusable Fleet button — `variant`/`color` pick the look (styling is global, in theme/Components).
 * `isLoading` shows a centered spinner over a transparent label while the button is disabled.
 */
interface CustomButtonProps extends ButtonProps {
  isLoading?: boolean;
  component?: React.ElementType;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  className,
  variant = 'contained',
  color,
  isLoading = false,
  disabled,
  startIcon,
  children,
  style,
  ...props
}) => {
  const resolvedColor = color ?? (variant === 'outlined' ? 'default' : 'secondary');
  return (
    <Button
      disableElevation
      variant={variant}
      color={resolvedColor}
      className={className}
      style={{ position: 'relative', ...style }}
      disabled={disabled || isLoading}
      startIcon={isLoading ? undefined : startIcon}
      {...props}
    >
      {isLoading && (
        <span className="btn-loading-indicator">
          <CircularProgress size={18} color="inherit" />
        </span>
      )}
      <span className={isLoading ? 'btn-loading-label' : undefined}>{children}</span>
    </Button>
  );
};

export default CustomButton;
